import { Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Header action that opens Google Maps turn-by-turn directions from
 * the phone's current location to the project site.
 *
 * We build a `google.com/maps/dir/?api=1&destination=lat,lng` URL —
 * Google's universal deep link that opens the native Google Maps app
 * on iOS/Android when installed and falls back to google.com/maps in
 * the browser otherwise. No Maps API quota is consumed (it's a plain
 * link, not a JS API call).
 *
 * Navigation is intentionally LAT/LNG-ONLY. Street addresses aren't
 * reliable for tower sites (many are off a numbered county road, or
 * the address on record is a leasing office miles away). Requiring
 * coords forces the office to enter the correct pin location so the
 * crew doesn't drive to the wrong place. If coords are missing the
 * button is hidden.
 */
export default function NavigateButton({ project }) {
  const lat = project?.latitude;
  const lng = project?.longitude;

  if (typeof lat !== "number" || typeof lng !== "number") return null;

  const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="navigate-to-site-btn"
    >
      <Button
        size="sm"
        className="bg-emerald-600 hover:bg-emerald-700 text-white h-8 px-3"
        title="Open Google Maps with turn-by-turn to this site"
      >
        <Navigation className="w-3.5 h-3.5 mr-1.5" />
        Navigate
      </Button>
    </a>
  );
}
